import { useEffect, useState } from 'react'
import { api } from './api'
import type { Season } from './types'

// De publieke seizoensinfo komt van /api/season: enkel in-memory vlaggen, geen
// Notion. Dit hing eerst aan /api/spots, maar die doet voor zijn bezet-vlaggen
// een volledige gepagineerde listAll() — en geen enkele lezer hieronder
// rendert een kaart. `/praktisch` en `/reglement` staan bovendien in de voet
// van élke uitgaande mail, dus dat was een alle-rijen-lezing per bezoeker,
// binnen dezelfde ~3 requests/seconde als inschrijven en /beheer.
// Wie de kaart wél tekent (MijnPlek, Kaart, Plattegrond) leest `season` gewoon
// mee uit de call die hij toch al doet.
export function useSeason(): { season: Season | null; waitlist: boolean; loading: boolean } {
  const [season, setSeason] = useState<Season | null>(null)
  const [waitlist, setWaitlist] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let alive = true
    api<{ season?: Season; waitlist?: boolean }>('/api/season').then((res) => {
      if (!alive) return
      if (res.ok) {
        setSeason(res.data.season ?? null)
        setWaitlist(res.data.waitlist === true)
      }
      setLoading(false)
    })
    return () => { alive = false }
  }, [])

  return { season, waitlist, loading }
}

// "vanaf mei 2027" — valt terug op een zin zonder maand als de datum ontbreekt.
export function reopenSentence(season: Season | null): string {
  const label = season?.reopensLabel
  return label ? `vanaf ${label}` : 'in het voorjaar'
}

// "zaterdag 12 september 2026" van de lopende editie, met hoofdletter — of ''
// als de organisator de datum nog niet ingevuld heeft in /beheer. Elke zin die
// dit gebruikt moet een variant zonder datum hebben: leeg is een normale
// toestand, geen fout (zie `eventDates` in server/state.ts).
export function eventDateSentence(season: Season | null): string {
  const label = season?.eventDateLabel ?? ''
  return label ? label.charAt(0).toUpperCase() + label.slice(1) : ''
}
